import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';

import { AppModule } from './app.module';

// Zone.js (included in polyfills.js) patches Promise but omits .finally() in this version.
// Patch it here so Chrome extensions and other code that calls .finally() don't break.
if (typeof Promise !== 'undefined' && !Promise.prototype['finally']) {
  Promise.prototype['finally'] = function(callback) {
    return this.then(
      value  => Promise.resolve(callback()).then(() => value),
      reason => Promise.resolve(callback()).then(() => { throw reason; })
    );
  };
}

enableProdMode();
platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/app/main.ts